import { useState } from 'react'
import { TransactionPaymentState } from '../models/transaction.model'
import { getCurrentEndDate, getVendingStartDate } from '../utils/filter.utils'


export const useVendingFilterForm = () => {

    const StatusInitValue = [{ value: TransactionPaymentState.OK, label: TransactionPaymentState.OK }]

    //FILTERS FROM ENV
    const [startDate, setStartDate] = useState(getVendingStartDate())
    const [endDate, setEndDate] = useState(getCurrentEndDate())

    const [selectDateFromToHook, setSelectedDateFromToHook] = useState({ startDate, endDate })
    const [selectedPaymentChannelsHook, setSelectedPaymentChannelsHook] = useState([]);
    const [selectedStatusHook, setSelectedStatusHook] = useState(StatusInitValue)
    const [selectedMonthYearHook, setSelectedMonthYearHook] = useState([]);
    const [selectedDaysRangeHook, setSelectedDaysRangeHook] = useState(null);
    const [selectedMachineNames, setSelectedMachineNames] = useState([]);

    return {
        StatusInitValue,
        startDate,
        endDate,

        selectDateFromToHook,
        selectedStatusHook,
        selectedPaymentChannelsHook,
        selectedMonthYearHook,
        selectedDaysRangeHook,
        selectedMachineNames,

        setStartDate,
        setEndDate,

        setSelectedDateFromToHook,
        setSelectedPaymentChannelsHook,
        setSelectedStatusHook,
        setSelectedMonthYearHook,
        setSelectedDaysRangeHook,
        setSelectedMachineNames
    }
}